import star from '../../../../../../assets/icons/star.svg';
import goldCup from '../../../../../../assets/icons/cups/goldenCup.svg';
import silverCup from '../../../../../../assets/icons/cups/silverCup.svg';
import bronzeCup from '../../../../../../assets/icons/cups/bronzeCup.svg';

const icons = [goldCup, silverCup, bronzeCup, star];

export default icons;